<template>
    <div>

        <div v-if="resultsData.length === 0" class="font-weight-bold text-center py-5">

            <div class="mb-3">
                {{ __('import.There is no bet to import at the moment') }}
            </div>

            <a href="/bets" class="btn btn-light">
                {{ __('import.Go back') }}
            </a>

        </div>

        <b-table
            id="import-table"
            v-show="resultsData.length > 0"
            :items="resultsData"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            striped
            responsive
            hover>

            <template v-slot:cell(date)="row">

                <button
                    v-b-modal="'editDate' + row.item.id"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">
                    {{ row.item.date | moment('DD/MM/YYYY') }}
                </button>

                <b-modal
                    :id="'editDate' + row.item.id"
                    title="Edit Date"
                    centered
                    hide-header
                    hide-footer>

                    <b-form-datepicker
                        v-model="row.item.date"
                        :locale="locale"
                        @input="changeDate('editDate' + row.item.id)">
                    </b-form-datepicker>
                </b-modal>

            </template>

            <template v-slot:cell(fk_sport)="row">
                <span v-if="row.item.sport.translated">
                    {{ row.item.sport.translated }}
                </span>
                <span v-else>
                    {{ row.item.sport.eng_translated }}
                </span>
            </template>

            <template v-slot:head(fk_market)="data">
                <span class="">
                    {{ data.label }}
                </span>
                <a href="javascript:;" v-b-modal="'editMarketAll'" class="ml-1">
                    {{ __('import.Change All') }}
                </a>
            </template>

            <template v-slot:cell(fk_market)="row">

                <button
                    v-b-modal="'editMarket' + row.item.id"
                    type="button"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">

                    <span v-if="row.item.fk_market">
                        <span v-if="row.item.market.translated">
                            {{ row.item.market.translated }}
                        </span>
                        <span v-else>
                            {{ row.item.market.eng_translated }}
                        </span>
                    </span>
                    <span v-else>
                        <i class="fas fa-exclamation-circle mr-1 text-danger"></i> ---
                    </span>
                </button>

                <b-modal
                    :id="'editMarket' + row.item.id"
                    @show="listAllMarketAndStrategiesFromSport(row.item.fk_sport)"
                    title="Edit Market"
                    centered
                    hide-header
                    hide-footer>

                    <!-- Market / Strategies -->
                    <div class="form-group">
                        <label class="">{{ __('bets.Market / Strategy') }} *</label>

                        <v-select
                            v-model="row.item.fk_market"
                            :options="markets"
                            :selectable="option => option.type == 'item'"
                            :reduce="market => market.id"
                            @input="changeMarket(row.item.fk_market, row.item.market, 'editMarket' + row.item.id)"
                            label="name">

                            <template #option="{ type, name }">

                                <span v-if="type == 'group'" class="font-weight-bold text-secondary">
                                    {{ name }}
                                </span>

                                <span v-if="type == 'item'" class="">
                                    {{ name }}
                                </span>

                            </template>

                        </v-select>

                    </div>

                </b-modal>

            </template>

            <template v-slot:cell(fk_competition)="row">

                <button
                    v-b-modal="'editCompetition' + row.item.id"
                    type="button"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">

                    <span v-if="row.item.fk_competition">
                        <span v-if="row.item.competition.translated">
                            {{ row.item.competition.translated }}
                        </span>
                        <span v-else>
                            {{ row.item.competition.eng_translated }}
                        </span>
                    </span>
                    <span v-else>
                        ---
                    </span>
                </button>

                <b-modal
                    :id="'editCompetition' + row.item.id"
                    @show="listAllCompetitionsFromSport(row.item.fk_sport)"
                    title="Edit Competition"
                    centered
                    hide-header
                    hide-footer>

                    <!-- Competitions -->
                    <div class="form-group">

                        <label class="">{{ __('bets.Competition') }}</label>

                        <v-select
                            v-model="row.item.fk_competition"
                            :options="competitions"
                            :selectable="option => option.type == 'item'"
                            :reduce="competition => competition.id"
                            @input="changeCompetition(row.item.fk_competition, row.item.competition, 'editCompetition' + row.item.id)"
                            label="name">

                            <template #option="{ type, name }">

                                <span v-if="type == 'group'" class="font-weight-bold text-secondary">
                                    {{ name }}
                                </span>

                                <span v-if="type == 'item'" class="">
                                    {{ name }}
                                </span>

                            </template>

                        </v-select>

                    </div>

                </b-modal>

            </template>

            <template v-slot:head(stake)="data">
                <span class="">
                    {{ data.label }}
                </span>
                <a href="javascript:;" v-b-modal="'editStakeAll'" class="ml-1 text-sm">
                    {{ __('import.Change All') }}
                </a>
            </template>

            <template v-slot:cell(stake)="row">

                <button
                    v-b-modal="'editStake' + row.item.id"
                    type="button"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">

                    <i class="fas fa-exclamation-circle mr-1 text-danger" v-if="row.item.stake <= 0"></i>

                    {{ row.item.stake | currency(symbol) }}

                </button>

                <b-modal
                    :id="'editStake' + row.item.id"
                    title="Edit Stake"
                    centered
                    hide-header
                    hide-footer>

                    <!-- Stake -->
                    <div class="form-group">

                        <label class="">{{ __('bets.Stake') }}</label>

                        <currency-input
                            :locale="locale"
                            :currency='currency'
                            class="form-control font-weight-bold"
                            v-model="row.item.stake"
                            :allow-negative="false"
                            @change="changeStake('editStake' + row.item.id)"
                        />

                    </div>

                </b-modal>

            </template>

            <template v-slot:cell(result)="row">

                <button
                    v-b-modal="'editResult' + row.item.id"
                    type="button"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">

                    <span :class="{'text-success': row.item.result > 0, 'text-info': row.item.result == 0, 'text-danger': row.item.result < 0}">
                        {{ row.item.result | currency(symbol) }}
                    </span>

                </button>

                <b-modal
                    :id="'editResult' + row.item.id"
                    title="Edit Result"
                    centered
                    hide-header
                    hide-footer>

                    <!-- Result -->
                    <div class="form-group">

                        <label class="">{{ __('bets.Result') }}</label>

                        <currency-input
                            :locale="locale"
                            :currency='currency'
                            class="form-control font-weight-bold"
                            v-model="row.item.result"
                            @change="changeResult('editResult' + row.item.id)"
                        />

                    </div>

                </b-modal>

            </template>

            <template v-slot:cell(description)="row">

                <button
                    v-b-modal="'editDescription' + row.item.id"
                    type="button"
                    class="btn btn-default py-0 px-1 font-weight-normal underline line-custom">

                    <span v-if="row.item.description">
                        {{ row.item.description }}
                    </span>
                    <span v-else>
                        ---
                    </span>

                </button>

                <b-modal
                    :id="'editDescription' + row.item.id"
                    title="Edit Description"
                    centered
                    hide-header
                    hide-footer>

                    <!-- Description -->
                    <div class="form-group">

                        <label class="">{{ __('bets.Description') }}</label>

                        <textarea
                            class="form-control"
                            v-model="row.item.description"
                            maxlength="600"
                            @change="changeDescription('editDescription' + row.item.id)"
                            >
                        </textarea>

                    </div>

                </b-modal>

            </template>

        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="resultsData.length"
            :per-page="perPage"
            aria-controls="import-table"
        ></b-pagination>

        <div v-show="resultsData.length > 0" class="form-group text-right">

            <a href="/bets" class="btn btn-default mr-3">
                Cancelar
            </a>

            <button type="button" class="btn btn-primary" @click="importResults" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="loading"></span>
                {{ __('import.Import Results') }}
            </button>

        </div>

        <!-- Modal Market All -->
        <b-modal
            id="editMarketAll"
            @show="listAllMarketAndStrategiesFromSport(searchSportMoreCommon())"
            title="Edit Market"
            centered
            hide-header
            hide-footer>

            <!-- Market / Strategies -->
            <div class="form-group">
                <label class="">{{ __('bets.Market / Strategy') }} *</label>

                <v-select
                    v-model="fk_market"
                    :options="markets"
                    :selectable="option => option.type == 'item'"
                    :reduce="market => market.id"
                    @input="changeMarketAll(fk_market, searchSportMoreCommon())"
                    label="name">

                    <template #option="{ type, name }">

                        <span v-if="type == 'group'" class="font-weight-bold text-secondary">
                            {{ name }}
                        </span>

                        <span v-if="type == 'item'" class="">
                            {{ name }}
                        </span>

                    </template>

                </v-select>

            </div>

        </b-modal>

        <!-- Modal Stake All -->
        <b-modal
            id="editStakeAll"
            title="Edit Stake"
            centered
            hide-header
            hide-footer>

            <!-- Stake -->
            <div class="form-group">

                <label class="">{{ __('bets.Stake') }}</label>

                <currency-input
                    :locale="locale"
                    :currency='currency'
                    class="form-control font-weight-bold"
                    v-model="stake"
                    :allow-negative="false"
                    @change="changeStakeAll(stake)"
                />

            </div>

        </b-modal>

    </div>
</template>

<script>
    export default {
        props: {
            results: {
                type: Array,
                default: []
            },
            isBetfair: {
                type: Boolean,
                default: false
            },
            isFirstImportBetfair: {
                type: Boolean,
                default: false,
            },
            endpointImport: {
                type: String,
                default: ''
            },
            locale: {
                type: String
            },
            currency: {
                type: String
            },
            symbol: {
                type: String,
                default: '$'
            },
            perPage: {
                type: Number,
                default: 15
            },
        },
        computed: {
            symbolCurrency() {
                return this.symbol;
            }
        },
        data() {
            return {
                loading: false,
                resultsData: this.results,
                fields: [
                    { key: 'date', label: this.__('bets.Date') },
                    { key: 'fk_sport', label: this.__('bets.Sport') },
                    { key: 'fk_event', label: this.__('bets.Event') },
                    { key: 'fk_market', label: this.__('bets.Market') },
                    { key: 'fk_competition', label: this.__('bets.Competition') },
                    { key: 'stake', label: this.__('bets.Stake') },
                    { key: 'result', label: this.__('bets.Result') },
                    { key: 'description', label: this.__('bets.Description') },
                ],
                markets: [],
                competitions: [],
                fk_market: null,
                stake: null,
                currentPage: 1
            }
        },
        methods: {
            async importResults() {

                let checkMarket = await this.checkMarket();
                let checkStake = await this.checkStake();

                if (!checkMarket) {
                    this.$toast.error(this.__('import.You need to select the betting markets'));
                }

                if (!checkStake) {
                    this.$toast.error(this.__('import.You need to select stakes'));
                }

                if (checkMarket && checkStake) {
                    this.loading = true;
                    axios.post(this.endpointImport, {
                        bets: this.resultsData,
                        isBetfair: this.isBetfair,
                        isFirstImportBetfair: this.isFirstImportBetfair
                    })
                        .then(result => {
                            if (result.redirect) {
                                window.location = result.redirect
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            },
            checkMarket() {
                let canExecute = true;
                this.resultsData.forEach((element) => {
                    if (element.fk_market == null) {
                        canExecute = false;
                    }
                })
                return canExecute;
            },
            checkStake() {
                let canExecute = true;
                this.resultsData.forEach((element) => {
                    if (!element.stake) {
                        canExecute = false;
                    }
                })
                return canExecute;
            },
            changeDate(id) {
                // Close Modal
                this.$bvModal.hide(id)
            },
            listAllMarketAndStrategiesFromSport(fk_sport) {
                axios.get(`/bets/markets-and-strategies/${fk_sport}`)
                    .then(result => {
                        this.markets = result
                    })
            },
            changeMarket(fk_market, market, id) {

                // Search Name
                let marketName = this.searchMarketName(fk_market);

                // Update
                market.description = marketName;
                market.translated = marketName;
                market.eng_translated = marketName;

                // Close Modal
                this.$bvModal.hide(id)
            },
            changeMarketAll(fk_market, fk_sport) {

                // Search Name
                let marketName = this.searchMarketName(fk_market);

                this.resultsData.forEach((element, key) => {
                    if (element.fk_sport === fk_sport) {
                        // Update
                        this.resultsData[key].fk_market = fk_market;
                        this.resultsData[key].market.description = marketName;
                        this.resultsData[key].market.translated = marketName;
                        this.resultsData[key].market.eng_translated = marketName;
                    }
                });

                this.$bvModal.hide('editMarketAll');

                this.fk_market = null;
            },
            changeStakeAll(stake) {

                this.resultsData.forEach((element, key) => {
                    // Update
                    this.resultsData[key].stake = stake;
                });

                this.$bvModal.hide('editStakeAll');

                this.stake = null;
            },
            searchMarketName(fk_market) {
                let string = '---';
                this.markets.forEach(element => {
                   if (element.id === fk_market) {
                       string = element.name;
                   }
                });
                return string;
            },
            listAllCompetitionsFromSport(fk_sport) {
                axios.get(`/bets/competitions/${fk_sport}`)
                    .then(result => {
                        this.competitions = result
                    })
            },
            changeCompetition(fk_competition, competition, id) {
                // Search Name
                let competitionName = this.searchCompetitionName(fk_competition);

                // Update
                competition.description = competitionName;
                competition.translated = competitionName;
                competition.eng_translated = competitionName;

                // Close Modal
                this.$bvModal.hide(id)
            },
            searchCompetitionName(fk_competition) {
                let string = '---';
                this.competitions.forEach(element => {
                    if (element.id === fk_competition) {
                        string = element.name;
                    }
                });
                return string;
            },
            changeStake(id) {
                // Close Modal
                this.$bvModal.hide(id)
            },
            changeResult(id) {
                // Close Modal
                this.$bvModal.hide(id)
            },
            changeDescription(id) {
                // Close Modal
                this.$bvModal.hide(id)
            },
            searchSportMoreCommon() {
                return 1;
            }
        }
    }
</script>

<style scoped>
    .underline {
        border-bottom: dashed 1px #42BEC2;
    }
    .line-custom {

    }
</style>
